import { Instagram, Linkedin, Youtube, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#0a192f] text-white pt-16 md:pt-24 pb-8"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        {/* Massive wordmark */}
        <div className="relative border-t border-white/10 py-16 md:py-24">
          <h3 className="font-display font-medium tracking-[-0.045em] leading-[0.85] text-[20vw] md:text-[16vw] text-white">
            Edufly<span className="text-[#00A3FF]">.</span>
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 border-t border-white/10 pt-10">
          <div className="col-span-2 md:col-span-5">
            <div className="font-mono-tech text-[10px] tracking-widest text-white/40 mb-3">
              MANIFESTO
            </div>
            <p className="text-white/80 font-body max-w-sm leading-relaxed">
              We engineer departures, not dreams. From first shortlist to first
              week overseas — Edufly stays with you.
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-widest text-white/40 mb-3">
              STUDIO
            </div>
            <ul className="space-y-2 text-white/85">
              <li><a href="#services" className="hover:text-[#00A3FF]">Services</a></li>
              <li><a href="#destinations" className="hover:text-[#00A3FF]">Destinations</a></li>
              <li><a href="#manifesto" className="hover:text-[#00A3FF]">Manifesto</a></li>
              <li><a href="#testimonials" className="hover:text-[#00A3FF]">Voices</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-widest text-white/40 mb-3">
              OFFICE
            </div>
            <ul className="space-y-2 text-white/85 text-sm">
              <li>Bareilly · India</li>
              <li>Warsaw · Poland</li>
              <li>
                <a
                  href="mailto:infoflyedu@gmail.com"
                  className="hover:text-[#00A3FF] transition-colors"
                  data-testid="footer-email-link"
                >
                  infoflyedu@gmail.com
                </a>
              </li>
            </ul>
            <a
              href="/edufly-brochure.pdf"
              download="Edufly-Brochure.pdf"
              className="mt-5 inline-flex items-center gap-2 font-mono-tech text-[10px] tracking-widest text-[#00A3FF] hover:text-white border border-[#00A3FF]/40 hover:border-white rounded-full px-4 py-2 transition-colors"
              data-testid="footer-brochure-download"
            >
              ↓ DOWNLOAD BROCHURE
            </a>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono-tech text-[10px] tracking-widest text-white/40 mb-3">
              SOCIAL
            </div>
            <div className="flex items-center gap-3">
              {[Instagram, Linkedin, Youtube, Twitter].map((Ic, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#00A3FF] hover:border-[#00A3FF] transition-colors"
                  aria-label={`social-${i}`}
                  data-testid={`footer-social-${i}`}
                >
                  <Ic size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 font-mono-tech text-[10px] text-white/40 tracking-widest">
          <span>© 2025 EDUFLY CONSULTANCY. ALL RIGHTS RESERVED.</span>
          <span>DESIGNED WITH INTENT · BUILT FOR DEPARTURE</span>
        </div>
      </div>
    </footer>
  );
}
